<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <div class="in-two-columns">
    <!-- type -->

    <mat-form-field>
      <app-easy-select
        formControlName="type"
        [label]="TITLE + 'FRUIT_SPIRIT_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FRUIT_SPIRIT_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="types | toSelectOption: 'PRODUCTS.FRUIT_SPIRIT_TYPE.'"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- brewingProcess -->

    <mat-form-field *ngIf="getCtrl('brewingProcess')">
      <app-easy-select
        formControlName="brewingProcess"
        [label]="TITLE + 'BREWING_PROCESS' | translate"
        [translatePrefixForSelected]="'PRODUCTS.BREWING_PROCESS.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          brewingProcesses | toSelectOption: 'PRODUCTS.BREWING_PROCESS.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- flavor -->

    <mat-form-field>
      <app-easy-select
        formControlName="flavor"
        [label]="TITLE + 'FRUIT_SPIRIT_FLAVOR' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FRUIT_SPIRIT_FLAVOR.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          flavors | toSelectOption: 'PRODUCTS.FRUIT_SPIRIT_FLAVOR.':true
        "
        (ngModelChange)="onFlavorSelected($event)"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- otherFlavor -->

    <mat-form-field *ngIf="getCtrl('otherFlavor')">
      <app-easy-select
        formControlName="otherFlavor"
        [label]="TITLE + 'FRUIT_SPIRIT_OTHER_FLAVOR' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FRUIT_SPIRIT_OTHER_FLAVOR.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          otherFlavors
            | toSelectOption: 'PRODUCTS.FRUIT_SPIRIT_OTHER_FLAVOR.':true
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- vegetableFlavor -->

    <mat-form-field *ngIf="getCtrl('vegetableFlavor')">
      <app-easy-select
        formControlName="vegetableFlavor"
        [label]="TITLE + 'FRUIT_SPIRIT_VEGETABLE_FLAVOR' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FRUIT_SPIRIT_VEGETABLE_FLAVOR.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          vegetableFlavors
            | toSelectOption: 'PRODUCTS.FRUIT_SPIRIT_VEGETABLE_FLAVOR.':true
        "
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <!-- agingMethod -->

  <mat-form-field *ngIf="getCtrl('agingMethod')">
    <app-easy-select
      formControlName="agingMethod"
      [label]="TITLE + 'AGING_METHOD' | translate"
      [translatePrefixForSelected]="'PRODUCTS.AGING_METHOD.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [options]="agingMethods | toSelectOption: 'PRODUCTS.AGING_METHOD.'"
    >
    </app-easy-select>
  </mat-form-field>
</fieldset>
